import React, { useState, Fragment } from 'react'
import moment from 'moment'
import Hidden from '@material-ui/core/Hidden'
import Paper from '@material-ui/core/Paper'
import Avatar from '@material-ui/core/Avatar'
import IconButton from '@material-ui/core/IconButton'
import {
  Popper,
  Fade,
  ClickAwayListener,
  List,
  ListItem,
  ListItemText,
  Link,
} from '@material-ui/core/'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { IMAGE_EO_PATH, TM_WEB_PATH } from '../../config/constants'
import PersonIcon from '@material-ui/icons/Person'
import useStyles from './styled'

const EventName = props => {
  const { eventDetail, eo, isEntry } = props
  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const classes = useStyles({
    eventStyles: eventDetail.style,
  })
  const handleOpen = event => {
    event.preventDefault()
    setOpen(!open)
    setAnchorEl(event.currentTarget)
  }
  const handleClose = event => {
    if (anchorEl.contains(event.target)) return
    setOpen(!open)
  }
  const eoLogo =
    eo.img_logo && eo.img_logo.length > 0 ? eo.img_logo[eo.img_logo.length - 1] : 'default.png'

  const start = moment(eventDetail.show_starttime).locale('EN')
  const end = moment(eventDetail.show_endtime).locale('EN')
  const diffDay = start.diff(end, 'days')
  return (
    <Fragment>
      <Hidden smDown>
        <div className={classes.eventBox}>
          <div className={classes.eventBoxDate}>
            {diffDay !== 0 ? (
              <Fragment>
                <span className="days">{`${start.format('DD')}-${end.format('DD')}`}</span>
                <br />
                {start.format('MMM') == end.format('MMM') ? (
                  <span>{`${start.format('MMM')}`}</span>
                ) : (
                  <span>{`${end.format('MMM')}`}</span>
                )}
              </Fragment>
            ) : (
              <Fragment>
                <span className="days">{start.date()}</span>
                <br />
                <span>
                  <span className="day">{start.format('ddd')}/</span>
                  {`${start.format('MMM')}`}
                </span>
              </Fragment>
            )}
          </div>
          <div className={classes.eventBoxName}>{eventDetail.name}</div>
        </div>
      </Hidden>
      <Hidden mdUp>
        {isEntry ? (
          <Paper className={classes.paperMobile}>
            <div className={classes.box}>
              <div className={classes.boxFix}>
                <Avatar
                  className={classes.avatar}
                  children={<PersonIcon className={classes.avatarIcon} />}
                  src={IMAGE_EO_PATH + eoLogo}
                />
              </div>
              <div className={classes.boxName}>
                {eventDetail.name}
                <br />
                {diffDay !== 0 ? (
                  <span className="days">
                    {start.format('DD')}-{end.format('DD')}
                    {start.format('MMM') == end.format('MMM') ? (
                      <span>{` ${start.format('MMM')} ${start.format('YYYY')}`}</span>
                    ) : (
                      <span>{` ${end.format('MMM')} ${end.format('YYYY')}`}</span>
                    )}
                  </span>
                ) : (
                  <span className="days">
                    {`${start.format('YYYY')}.${start.format('MM')}.${start.format('DD')}`}
                  </span>
                )}
              </div>
              <div className={classes.boxFix}>
                <IconButton disableRipple className={classes.iconButton} onClick={handleOpen}>
                  <MoreVertIcon className={classes.iconMore} />
                </IconButton>
              </div>
              <Popper
                open={open}
                anchorEl={anchorEl}
                placement="bottom"
                transition
                disablePortal
                className={classes.popper}
              >
                {({ TransitionProps, placement }) => (
                  <Fade {...TransitionProps} timeout={500}>
                    <Paper className={classes.paperPopup}>
                      <ClickAwayListener onClickAway={handleClose}>
                        <List component="nav" className={classes.rootList}>
                          <Link href={TM_WEB_PATH + eo.slug} target="_blank" underline="none">
                            <ListItem button className={classes.rootListItem}>
                              <ListItemText
                                disableTypography
                                primary={'Event Organzier'}
                                className={classes.rootListItemText}
                              />
                            </ListItem>
                          </Link>
                        </List>
                      </ClickAwayListener>
                    </Paper>
                  </Fade>
                )}
              </Popper>
            </div>
          </Paper>
        ) : (
          <div className={classes.eventBox}>
            <div className={classes.eventBoxDate}>
              {diffDay !== 0 ? (
                <Fragment>
                  <span className="days">{`${start.format('DD')}-${end.format('DD')}`}</span>
                  <br />
                  {start.format('MMM') == end.format('MMM') ? (
                    <span>{`${start.format('MMM')}`}</span>
                  ) : (
                    <span>{`${end.format('MMM')}`}</span>
                  )}
                </Fragment>
              ) : (
                <Fragment>
                  <span className="days">{start.date()}</span>
                  <br />
                  <span>
                    <span className="day">{start.format('ddd')}/</span>
                    {`${start.format('MMM')}`}
                  </span>
                </Fragment>
              )}
            </div>
            <div className={classes.eventBoxName}>{eventDetail.name}</div>
          </div>
        )}
      </Hidden>
    </Fragment>
  )
}

export default EventName
